<template>
    <v-row class="no-frame pb-0 pt-0" v-if="data && data.responsibility" style="display: flex">
        <v-col class="no-frame">
            <v-checkbox
                v-model = "data.selected"
                :label  = "data.responsibility.name"
                :ripple = "false"
                @click  = "onSelected"
                class   = "mt-1 pt-0"
                hide-details
            />
        </v-col>
        <v-col class="no-frame col-auto v-flex">
            <v-radio-group
                v-model   = "type"
                class     = "ma-0"
                :disabled = "!this.data.selected"
                hide-details
                dense
                row
            >
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <div
                            v-bind = "attrs"
                            v-on   = "on"
                        >
                            <v-radio
                                :ripple = "false"
                                class   = "mt-0 pt-0 ma-0"
                                @click  = "onType"
                                hide-details
                            />
                        </div>
                    </template>
                    <span >An</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <div
                            v-bind = "attrs"
                            v-on   = "on"
                        >
                            <v-radio
                                :ripple = "false"
                                class   = "mt-0 pt-0 ma-0"
                                @click  = "onType"
                                color   = "primary lighten-4"
                                hide-details
                            />
                        </div>
                    </template>
                    <span>CC</span>
                </v-tooltip>
            </v-radio-group>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "ContactResponsiblity",

    props: {
        item: {
            required: false,
            type    : Object,
        },
    },

    data: () => ({
        data  : {
            selected      : null,
            responsibility: null,
            mail          : null,
            cc            : null
        },
        type  : null
    }),

    mounted() {
        this.data = this.item;
        this.type = this.data.mail ? 0 : 1;
        this.onType();
    },

    methods: {
        onSelected () {
            if (this.data.selected) {
                this.data.mail = true;
                this.data.cc   = false;
            } else {
                this.data.mail = false;
                this.data.cc   = false;
                this.type      = null;
            }

            this.changed();
        },

        onType () {
            if (!this.data.selected) {
                this.type = null;
                return;
            }

            this.data.mail = this.type === 0;
            this.data.cc   = this.type === 1;
        },

        changed () {
            this.$emit("changed", this.data)
        }
    }
}
</script>

<style scoped>

</style>